import type { ListenerMiddlewareInstance } from '@reduxjs/toolkit';

import type { RootState } from '../../structureDefinitions/cartState';

import cartItemsSelectors, {
    cartItemUniqueIdPredicate,
} from '../../../../cart/selectors/cartItemsSelectors';
import { storeSelectors } from '../../../selectors/storeSelectors';
import { unsyncedCartItemsSelectors } from '../../../selectors/unsyncedCartItemsSelectors';
import { userProfileSelectors } from '../../../selectors/userProfileSelectors';
import { sendGaModifyCartEvent } from '../../../tracking/gaEventCreators';
import { unsyncedCartItemsActions } from '../../slices/unsyncedCartItemsSlice';

export const unsyncedAddToCartGaTrackingMiddleware = (
    middlewareInstance: ListenerMiddlewareInstance<RootState>,
) => {
    middlewareInstance.startListening({
        actionCreator: unsyncedCartItemsActions.removeUnsyncedCartItems,
        effect: async (action, listenerApi) => {
            listenerApi.cancelActiveListeners();

            const previousState = listenerApi.getOriginalState(); // the effect fires before removeUnsyncedCartItems actually changes the state, thats why we can access previousState

            const currentStoreId = storeSelectors.currentProductionUnit(previousState);
            const isUserMember = userProfileSelectors.isMember(previousState);
            const cartItems = cartItemsSelectors.selectAllCartItems(previousState);
            const unsyncedCartItems =
                unsyncedCartItemsSelectors.selectUnsyncedCartItems(previousState);

            const successfulyAddedCartItems = unsyncedCartItems.filter((unsyncedItem) =>
                cartItems.find((cartItem) =>
                    cartItemUniqueIdPredicate(cartItem.cartItemData, unsyncedItem),
                ),
            );

            successfulyAddedCartItems.filter(Boolean).forEach((cartItem) => {
                sendGaModifyCartEvent(
                    cartItem.productId,
                    cartItem.variantId,
                    cartItem.quantity,
                    0,
                    currentStoreId,
                    isUserMember,
                    cartItem?.analyticsOptions,
                );
            });
        },
    });
};
